module.exports = __webpack_public_path__ + "img/dsj32.8aae090d.svg";